import { IconInterface } from '../interfaces/icon.interface';

export const Checkmark = (props: IconInterface) => {
	const { color = '#FFF', width = 13, height = 10, strokeWidth = '3' } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="2.5 5.5 19 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 12.5 9.5 18 20 7"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
